import Welcome from "../../../jsx/pages/Welcome";

const LoginWrapper = function (props) {
  return <Welcome />;
};

export default constore(LoginWrapper);
